<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Báo cáo thời gian làm việc</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-combobox solo class="toolbar-item" v-model="selectedGroup" :items="group" label="Group"></v-combobox>
        <v-menu
          v-model="menuFromDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          class="mr-2"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fromDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="fromDate" @input="menuFromDate = false"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menuToDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          class="mr-2"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="toDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="toDate" @input="menuToDate = false"></v-date-picker>
        </v-menu>
      </v-toolbar-items>
        
      <v-btn class="mx-0" color="primary" @click="mapData" :disabled="disabledDownload">Download</v-btn>
      <v-btn color="success" outline round @click="exportFileExcel">Xuất file</v-btn>
    </v-toolbar>
    <v-divider></v-divider>

    <v-layout row wrap class="my-3">
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số case lắp đặt</v-card-text>
          <span class="display-1">{{total.Cases}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số xe lắp đặt</v-card-text>
          <span class="display-1">{{total.InstallQty}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số xe sửa chữa</v-card-text>
          <span class="display-1">{{total.RepairQty}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số lần bắt đầu trễ</v-card-text>
          <span class="display-1">{{total.StartedLate}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số lần kết thúc trễ</v-card-text>
          <span class="display-1">{{total.FinishedLate}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số lần gia hạn time</v-card-text>
          <span class="display-1">{{total.Delay}}</span>
        </v-card>
      </v-flex>
      <v-flex xs pa-2>
        <v-card class="pa-3">
          <v-card-text class="pa-0">Số lần báo cáo trễ</v-card-text>
          <span class="display-1">{{total.ReportLate}}</span>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>

    <v-data-table
      item-key="id"
      :headers="headers"
      :items="dataFilter"
      :rows-per-page-items="[10,20,50,100]"
      :loading="isLoading"
      class="table-worktime"
    >
      <template slot="items" slot-scope="props">
        <tr class="table-row">
          <td>{{ props.item.STT }}</td>
          <td>{{ props.item.Name }}</td>
          <td>{{ props.item.Cases }}</td>
          <td> {{ props.item.InstallQty }}</td>
          <td>{{ props.item.RepairQty }}</td>
          <td>{{ props.item.RePlan }}</td>
          <td>{{ props.item.MovedTime | convertMinuteToHour }}</td>
          <td>{{ props.item.WaitedTime | convertMinuteToHour }}</td>
          <td>{{ props.item.RepairedTime | convertMinuteToHour }}</td>
          <td>{{ props.item.WorkTime | convertMinuteToHour }}</td>
          <td>{{props.item.Distance}}</td>
          <td>
            <v-menu :close-on-content-click="false" offset-y offset-x max-height="200">
              <template v-slot:activator="{ on }">
                <label
                  color="primary"
                  dark
                  v-on="on"
                  style="cursor: pointer"
                >
                  {{ props.item.StartedLate }} ({{ props.item.StartedLateTime | convertMinuteToHour }})
                </label>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(i, index) in props.item.arrStartLate"
                  :key="index"
                >
                  <a :href="getCrmCaseUrl(i.Id)" target="_blank">{{ i.CaseNumber }}</a>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" offset-y offset-x max-height="200">
              <template v-slot:activator="{ on }">
                <label
                  color="primary"
                  dark
                  v-on="on"
                  style="cursor: pointer"
                >
                  {{ props.item.FinishedLate }} ({{ props.item.FinishedLateTime | convertMinuteToHour }})
                </label>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(i, index) in props.item.arrFinishLate"
                  :key="index"
                >
                  <a :href="getCrmCaseUrl(i.Id)" target="_blank">{{ i.CaseNumber }}</a>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          <!-- gia hạn time -->
          <td>
            
            <v-menu :close-on-content-click="false" offset-y offset-x max-height="200">
              <template v-slot:activator="{ on }">
                <label
                  color="primary"
                  dark
                  v-on="on"
                  style="cursor: pointer"
                >
                  {{ props.item.Delay}} ({{props.item.DelayTime | convertMinuteToHour }})
                </label>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(i, index) in props.item.arrDelayTime"
                  :key="index"
                >
                  <a :href="getCrmCaseUrl(i.Id)" target="_blank">{{ i.CaseNumber }}</a>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td> 
          <!-- gia hạn time -->
          <td>
            <v-menu :close-on-content-click="false" offset-y offset-x max-height="200">
              <template v-slot:activator="{ on }">
                <label
                  color="primary"
                  dark
                  v-on="on"
                  style="cursor: pointer"
                >
                  {{ props.item.NotCase }}
                </label>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(i, index) in props.item.arrNotCase"
                  :key="index"
                >
                  <a :href="getCrmCaseUrl(i.Id)" target="_blank">{{ i.CaseNumber }}</a>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          <td>
            <v-menu :close-on-content-click="false" offset-y offset-x max-height="200">
              <template v-slot:activator="{ on }">
                <label
                  color="primary"
                  dark
                  v-on="on"
                  style="cursor: pointer"
                >
                  {{ props.item.ReportLate }}
                </label>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(i, index) in props.item.arrReportLate"
                  :key="index"
                >
                  <a :href="getCrmCaseUrl(i.Id)" target="_blank">{{ i.CaseNumber }}</a>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
      <template v-slot:footer>
        <td colspan="2">
          <strong>Tổng</strong>
        </td>
        <td>
          <strong>{{total.Cases}}</strong>
        </td>
        <td>
          <strong>{{total.InstallQty}}</strong>
        </td>
        <td>
          <strong>{{total.RepairQty}}</strong>
        </td>
        <td>
          <strong>{{total.RePlan}}</strong>
        </td>
        <td>
          <strong>{{total.MovedTime | convertMinuteToHour }}</strong>
        </td>
        <td>
          <strong>{{total.WaitedTime | convertMinuteToHour }}</strong>
        </td>
        <td>
          <strong>{{total.RepairedTime | convertMinuteToHour }}</strong>
        </td>
        <!-- Thời gian làm việc -->
        <td><strong>{{total.WorkTime | convertMinuteToHour }}</strong></td>
        <!-- Thời gian làm việc -->
        <td>
          <strong>{{total.Distance | roundNumber}}</strong>
        </td>
        <td>
          <strong>{{total.StartedLate}} ({{ total.StartedLateTime | convertMinuteToHour }})</strong>
        </td>
        <td>
          <strong>{{total.FinishedLate}} ({{ total.FinishedLateTime | convertMinuteToHour }})</strong>
        </td>
        <!-- gia hạn time -->
        <td><strong>{{total.Delay}} ({{total.DelayTime | convertMinuteToHour }})</strong></td>
        <!-- gia hạn time -->
        <td>
          <strong>{{total.NotCase}}</strong>
        </td>
        <td>
          <strong>{{total.ReportLate}}</strong>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import validate from '@/utils/validate';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import {
  formatGMTToLocalTime,
  convertDateTimeToSecond2010,
  convertSecond2010ToDateTime,
  convertGMTToLocalTime
} from '@/utils/datetime';
import moment from 'moment';
import * as MapUtil from '@/utils/maputil';
import XLSX from 'xlsx';

export default {
  components: { },
  filters: {
    convertMinuteToHour (value) {
      if (!value) return 0;
      let hour = Math.floor(value / 60) > 0 ? Math.floor(value / 60) + 'h' : '';
      return hour + (value % 60) + 'p';
    },

    roundNumber (val) {
      return val.toFixed(1);
    }
  },
  data () {
    return {
      fromDate: moment().format('YYYY-MM-DD'),
      menuFromDate: false,
      toDate: moment().format('YYYY-MM-DD'),
      menuToDate: false,
      headers: [
        { text: 'STT', value: 'STT' },
        { text: 'Nhân viên', value: 'Name' },
        { text: 'Số case', value: 'Cases' },
        { text: 'Lắp đặt', value: 'InstallQty' },
        { text: 'Sửa chữa', value: 'RepairQty' },
        { text: 'Hẹn lại', value: 'RePlan' },
        { text: 'Thời gian di chuyển', value: 'MovedTime' },
        { text: 'Thời gian chờ', value: 'WaitedTime' },
        { text: 'Thời gian lắp đặt', value: 'RepairedTime' },
        { text: 'Thời gian làm việc', value: 'WorkTime' },
        { text: 'Số km', value: 'Distance' },
        { text: 'Bắt đầu trễ', value: 'StartedLate' },
        { text: 'Kết thúc trễ', value: 'FinishedLate' },
        { text: 'Gia hạn Time', value: 'Delay' },
        { text: 'Không bấm case', value: 'NotCase' },
        { text: 'Báo cáo trễ', value: 'ReportLate' },
      ],
      datasource: [],
      dataFilter: [],
      isLoading: false,
      total: {
        Cases: 0,
        Qty: 0,
        MovedTime: 0,
        RepairedTime: 0,
        WaitedTime: 0,
        DeadlineTime: 0,
        RePlan: 0,
        StartedLate: 0,
        StartedLateTime: 0,
        FinishedLate: 0,
        FinishedLateTime: 0,
        NotCase: 0,
        ReportLate: 0,
        InstallQty: 0,
        RepairQty: 0,
        Distance: 0,
        WorkTime: 0,
        Delay: 0,
        DelayTime: 0,
      },
      group: ['All', 'Group 1', 'Group 2', 'Group 3', 'Group 4'],
      selectedGroup: 'All',
      disabledDownload: true,
      test: '',
      fileName: ''
    };
  },
  computed: {},
  watch: {
    selectedGroup () {
      this.filterDataByGroup();
      this.calculateToTal(this.dataFilter);
    }
  },
  created () {
    this.mapData();
  },
  methods: {
    ...mapActions(['GetSupporters', 'GetAllCases', 'VehicleDailyReport', 'GetDailyTripReport']),
    async mapData () {
      this.disabledDownload = true;
      this.datasource = [];
      this.disabledDownload = true;
      this.isLoading = true;
      let suporters = await this.GetSupporters();
      let cases = await this.GetAllCases();
      
      if (cases.length > 0) {
        let params = {
          Ids: suporters.map(s => s.VehicleId),
          From: convertDateTimeToSecond2010(moment(this.fromDate).hour(5)),
          To: convertDateTimeToSecond2010(moment(this.toDate).hour(23))
        };
        let trips = await this.GetDailyTripReport(params);
        let dailyReport = await this.VehicleDailyReport(params);

        this.datasource = suporters.map((item, index) => {
          let obj = { ...item };
          let repair = 0; // Thời gian sửa chữa
          let deadline = 0;
          let wait = 0;
          let move = 0;
          let installQty = 0;
          let repairQty = 0;
          
          let replan = 0;
          let startLate = 0;
          let startLT = 0;
          let finishLate = 0;
          let finishLT = 0;
          let reportLate = 0;
          let notCase = 0;
          let delay = 0; // Số lần gia hạn
          let delayTime = 0; // Thời gian gia hạn
          let arrStartLate = [];
          let arrFinishLate = [];
          let arrReportLate = [];
          let arrNotCase = [];
          let arrDelayTime = [];

          let reportBySup = dailyReport.filter(a => a.VehicleId === Number(obj.VehicleId)); // Lấy thông tin xe của sup

          let arrayCase = cases.filter(c => {
            let date = moment(convertGMTToLocalTime(c.Plan)).format('YYYY-MM-DD');
            return (c.RepairPerson === item.Name && new Date(date) <= new Date(this.toDate) && new Date(date) >= new Date(this.fromDate));
          });

          if (arrayCase.length > 0) {
            // eslint-disable-next-line complexity
            arrayCase.forEach(i => {
              let planDate = i.RePlanTime && moment(i.RePlanTime) > moment(i.Plan) ? convertGMTToLocalTime(i.RePlanTime) : convertGMTToLocalTime(i.Plan);
              let endPlanDate = moment(planDate).add(Number(i.InstallationDuration), 'minutes');

              if ((i.Status === 'Re-Plan' || i.Status === 'RePlan') && i.RePlanTime) { ++replan } // Hẹn lại 
              else {
                let installTracker = i.InstallationTrackerQty.split('/');
                let installSensor = i.InstallationSensorQty.split('/');
                let installCamera = i.InstallationCameraQty.split('/');
                let installTaxi = i.InstallationCameraQty.split('/');
                installQty += Number(installTracker[0]) || 0 + Number(installSensor[0]) || 0 + Number(installCamera[0]) || 0 + Number(installTaxi[0]) || 0; // Tổng lắp đặt

                let repairTracker = i.RepairTrackerQty.split('/');
                let repairSensor = i.RepairSensorQty.split('/');
                let repairCamera = i.RepairCameraQty.split('/');
                let repairTaxi = i.RepairTaxiQty.split('/');
                repairQty += Number(repairTracker[0]) || 0 + Number(repairSensor[0]) || 0 + Number(repairCamera[0]) || 0 + Number(repairTaxi[0]) || 0; // Tổng sửa chữa
              }

              if (i.Started) {
                let startDate = convertGMTToLocalTime(i.Started);

                if (i.WaitingFrom) {
                  let waitDate = convertGMTToLocalTime(i.WaitingFrom);
                  wait += startDate.diff(waitDate, 'minutes');
                }
                
                let planDateAddWait = moment(planDate).add(wait, 'minutes');// Cộng thêm thời gian chờ để tính thời gian BD trễ: thời gian BD trễ = start - plan - wait
                if (startDate > planDateAddWait) {
                  ++startLate;
                  startLT += startDate.diff(planDateAddWait, 'minutes');
                  arrStartLate.push(i);
                }

                if (i.Finished) {
                  let finishDate = convertGMTToLocalTime(i.Finished);

                  let time = finishDate.diff(startDate, 'minutes'); // Thời gian hoàn thành 1 case
                  repair += time;
                  deadline += time > Number(i.InstallationDuration) ? time - Number(i.InstallationDuration) : 0;

                  let endDate = moment(startDate).add(i.InstallationDuration, 'minutes');
                  if (finishDate > endDate) {
                    let resultTime = finishDate.diff(endDate, 'minutes');
                    if (i.DelayFinish === 'True') { // Check gia hạn
                      ++delay;
                      delayTime += resultTime;
                      arrDelayTime.push(i);
                    }
                    else {
                      ++finishLate; // Kêt thúc trễ
                      finishLT += resultTime;
                      arrFinishLate.push(i);
                      if (finishLT >= 5) {
                        ++reportLate;
                        arrReportLate.push(i);
                      }
                    }
                  }
                }
              }
              else { 
                if (planDate < moment() && !i.WaitingFrom && i.Status !== 'Re-Plan' && i.Status !== 'RePlan') {
                  ++notCase; // Không bấm case
                  arrNotCase.push(i);
                } 
              }
            });

            let arrTrip = trips.filter(t => t.VehicleId === Number(item.VehicleId));
            move = this.calculateMovedTime(arrayCase, arrTrip, item.VehicleId); // Thời gian di chuyển
          }

          obj.RepairedTime = repair;
          obj.WaitedTime = wait;
          obj.Cases = arrayCase.length;
          obj.RePlan = replan;
          obj.StartedLate = startLate;
          obj.StartedLateTime = startLT;
          obj.FinishedLate = finishLate;
          obj.FinishedLateTime = finishLT;
          obj.ReportLate = reportLate;
          obj.NotCase = notCase;
          obj.arrayCase = arrayCase;
          obj.arrStartLate = arrStartLate;
          obj.arrFinishLate = arrFinishLate;
          obj.arrReportLate = arrReportLate;
          obj.arrNotCase = arrNotCase;
          obj.arrDelayTime = arrDelayTime;
          obj.DeadlineTime = deadline;
          obj.MovedTime = move;
          obj.InstallQty = installQty;
          obj.RepairQty = repairQty;
          obj.Distance = this.calculateTotalDistance(reportBySup);
          obj.WorkTime = repair + move + wait;
          obj.DelayTime = delayTime;
          obj.Delay = delay;
          obj.STT = index + 1;
          
          return obj;
        });
      }
      console.log('this.datasource', this.datasource);
      this.filterDataByGroup();
      this.calculateToTal(this.dataFilter);
      this.fileTime = this.fromDate !== this.toDate ? `${this.fromDate.replace(/-/gi, '')}-${this.toDate.replace(/-/gi, '')}` : this.fromDate.replace(/-/gi, '');
      this.isLoading = false;
      this.disabledDownload = false;

    },

    reset () {
      this.total = {
        Cases: 0,
        Qty: 0,
        MovedTime: 0,
        RepairedTime: 0,
        WaitedTime: 0,
        DeadlineTime: 0,
        RePlan: 0,
        StartedLate: 0,
        StartedLateTime: 0,
        FinishedLate: 0,
        FinishedLateTime: 0,
        NotCase: 0,
        ReportLate: 0,
        InstallQty: 0,
        RepairQty: 0,
        Distance: 0,
        WorkTime: 0,
        Delay: 0,
        DelayTime: 0,
      };
    },

    calculateMovedTime (cases, trips, vehicleID) {
      let total = 0;
      let arrTrips = trips.map((item) => {
        let obj = { ...item };
        obj.FromTimeFull = convertSecond2010ToDateTime(obj.FromTime);
        obj.ToTimeFull = convertSecond2010ToDateTime(obj.ToTime);
        return obj;
      });
      cases.forEach(item => {
        let start = convertGMTToLocalTime(item.Started);
        let trip = arrTrips.find(t => t.ToTimeFull >= moment(start).add(-20, 'minutes') && t.ToTimeFull <= moment(start).add(20, 'minutes'));
        if (trip) { total += trip.Duration - trip.StopTime }
      });
      return Math.ceil(total / 60);
    },
    getCrmCaseUrl (id) {
      return `http://vmcrm.quanlyxe.vn/index.php?module=Cases&action=DetailView&record=${id}`;
    },

    calculateToTal (array) {
      this.reset();
      array.forEach(item => {
        // Tổng footer
        this.total.RePlan += item.RePlan;// Tổng số lần hẹn lại
        this.total.StartedLate += item.StartedLate;// Tổng số lần bắt đầu trễ
        this.total.StartedLateTime += item.StartedLateTime;// Tổng thời gian bắt đầu trễ
        this.total.FinishedLate += item.FinishedLate;// Tổng số lần kết thúc trễ
        this.total.FinishedLateTime += item.FinishedLateTime;// Tổng thời gian kết thúc trễ
        this.total.ReportLate += item.ReportLate;// Tổng số lần báo cáo trễ
        this.total.NotCase += item.NotCase;// Tổng số lần không bấm case
        this.total.InstallQty += item.InstallQty;// Tổng đã lắp đặt
        this.total.RepairQty += item.RepairQty;// Tổng đã sửa chữa

        this.total.Cases += item.arrayCase.length;// Tổng case
        this.total.MovedTime += item.MovedTime;// Tổng thời gian di chuyển
        this.total.RepairedTime += item.RepairedTime;// Tổng thời gian sửa chữa
        this.total.WaitedTime += item.WaitedTime;// Tổng thời gian chờ
        this.total.DeadlineTime += item.DeadlineTime; // Tổng thời gian trễ deadline
        this.total.Distance += item.Distance; // Tổng số Km
        this.total.WorkTime += item.WorkTime; // Tổng thơi gian làm việc
        this.total.Delay += item.Delay;// Tổng số lần gia hạn
        this.total.DelayTime += item.DelayTime;// Tổng thời gian gia hạn
      });
    },

    calculateTotalDistance (array) {
      let arrayDistance = array.map(a => {
        if (a.FromTime) return a.GpsDistance > 0 ? Number((a.GpsDistance / 1000).toFixed(1)) : 0;
        return 0;
      });
      let distance = arrayDistance.reduce((a, b) => {
        return a + b;
      }, 0);
      return Number((distance / 1000).toFixed(1));
    },

    filterDataByGroup () {
      if (this.selectedGroup !== 'All') {
        this.dataFilter = this.datasource.filter(item => 'Group ' + item.Group === this.selectedGroup);
      }
      else { this.dataFilter = this.datasource } 
    },

    exportFileExcel () {

      let data = [];

      this.datasource.forEach(item => {
        let obj = {};
        obj['STT'] = item.STT;
        obj['Nhân viên'] = item.Name;
        obj['Số case'] = item.Cases;
        obj['Lắp đặt'] = item.InstallQty;
        obj['Sửa chữa'] = item.RepairQty;
        obj['Hẹn lại'] = item.RePlan;
        obj['Thời gian di chuyển'] = this.$options.filters.convertMinuteToHour(item.MovedTime);
        obj['Thời gian chờ'] = this.$options.filters.convertMinuteToHour(item.WaitedTime);
        obj['Thời gian lắp đặt'] = this.$options.filters.convertMinuteToHour(item.RepairedTime);
        obj['Thời gian làm việc'] = this.$options.filters.convertMinuteToHour(item.WorkTime);
        obj['Số km'] = item.Distance;
        obj['Bắt đầu trễ'] = `${item.StartedLate} (${this.$options.filters.convertMinuteToHour(item.StartedLateTime)})`;
        obj['Kết thúc trễ'] = `${item.FinishedLate} (${this.$options.filters.convertMinuteToHour(item.FinishedLateTime)})`;
        obj['Gia hạn Time'] = `${item.Delay} (${this.$options.filters.convertMinuteToHour(item.DelayTime)})`;
        obj['Không bấm case'] = item.NotCase;
        obj['Báo cáo trễ'] = item.ReportLate;

        data.push(obj);
      });
      console.log('exportFileExcel -> data', data);

      /* make the worksheet */
      let ws = XLSX.utils.json_to_sheet(data);

      // /* add to workbook */
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'WorkTime');

      // /* generate an XLSX file */
      XLSX.writeFile(wb, `Báo cáo thời gian làm việc-${this.fileTime}.xlsx`);
    }
  }
};
</script>

<style scoped>
.v-toolbar__items {
  padding: 7px !important;
}
.toolbar-item {
  width: 200px !important;
  margin-right: 8px !important;
}
.table-worktime{
  height: calc(100vh - 271px);
  max-height: 696px;
  overflow: hidden;
}
.table-worktime >>> table{
  height: 100%;
}
.table-worktime >>> thead, .table-worktime >>> tfoot{  
  display: table;
  width: calc(100% - 22px);
  table-layout: fixed;
  min-width: 1998px;
}
.table-worktime >>> tbody{  
  height: calc(100% - 105px);
  overflow-y: scroll;
  width: 100%;
  min-width: 2020px;
  display: block;
}
.table-worktime >>> tbody tr{  
  table-layout: fixed;
  display: table;
  width: 100%;
}
.table-worktime >>> .v-table__overflow{
  height: calc(100% - 59px);
}
</style>



// WEBPACK FOOTER //
// src/pages/reporting/WorkTime.vue